
export default {
  namespaced: true,

  state: {
    me: null,
    isMeSignedIn: false, // this need to set false, once new backend implemented
    scopedCompany: null,
  },

  mutations: {
    SET_ME(state, payload) {
      state.me = payload;
    },
    SET_IS_ME_SIGNED_IN(state, payload) {
      state.isMeSignedIn = payload;
    },
    SET_NEW_ACCESS_TOKEN(state, payload) {
      state.me.token = payload;
    },
  },

  actions: {
    async setMe({
      commit,
      dispatch,
    }, payload) {
      // receiving 'payload' from authGuard.js
      // this run only once when app is refreshed but in authGuard.js if you remove this condition:
      // `if (store.getters['users/isMeSignedIn'])` then this can run each time when
      // route changes only on `meta: { requiresAuth: true }`
      if (payload) {
        commit('SET_ME', payload);
        commit('SET_IS_ME_SIGNED_IN', true);

        dispatch('autoSelectFirstOrganization');
      }

      // // receiving 'try' request from app.vue without payload
      // // this run only once when app is refreshed
      // try {
      //   const user = await Auth.currentAuthenticatedUser();
      //   // const results = await getUserRecordByEmail(user.attributes.email);
      //   // const userRecord = results.data.getUserByEmail.items[0];
      //   // user.userRecord = userRecord;
      //   commit('SET_ME', user);
      //   commit('SET_IS_ME_SIGNED_IN', true);git branch -d
      // } catch (err) {
      //   // console.log('Is a Guest User');
      //   dispatch('resetMe');
      // }
    },

    resetMe({ commit }) {
      commit('SET_ME', null);
      commit('SET_IS_ME_SIGNED_IN', false);
      // Organizations belong to the signed-out user; the next one must not inherit them
      commit('organizations/MUTATE_SELECTED_ORGANIZATION', null, { root: true });
      commit('organizations/MUTATE_USER_MANAGED_ORGANIZATIONS', [], { root: true });
      // The web app's "acting as" organization goes too: the next user starts as themselves
      commit('actingEntity/RESET', null, { root: true });
      try {
        localStorage.removeItem('selectedOrganization');
      } catch {
        // storage unavailable: nothing to clear
      }
    },

    setIsMeSignedIn({ commit }, payload) {
      commit('SET_IS_ME_SIGNED_IN', payload);
    },

    async autoSelectFirstOrganization({ dispatch, rootGetters }) {
      const selectedOrg = rootGetters['organizations/GET_SELECTED_ORGANIZATION'];
      if (selectedOrg) return;
      // The API returns every organization to non-ORG users, so only org admins get one picked
      if (!rootGetters['users/isOrgAdmin']) return;

      try {
        // A Vuex action can't use composables (globalShared/useStore are undefined outside setup).
        // Lazy imports: @/graphs imports the store.
        const [{ makeRequest }, { findOrganizationsV2 }] = await Promise.all([
          import('@/graphs/index'), import('@/graphs/organization'),
        ]);
        const response = await makeRequest('query', findOrganizationsV2, {
          baseInput: { page: 1, pageSize: 20 },
        }, { token: rootGetters['users/me']?.token ?? null });
        if (response.errors?.length) throw new Error(response.errors[0].message);

        const organizations = response.data?.findOrganizationsV2 ?? [];
        const onboardedOrgs = organizations.filter((org) => org.onboarded);

        if (onboardedOrgs.length > 0) {
          const firstOrg = onboardedOrgs[0];
          dispatch('organizations/SET_SELECTED_ORGANIZATION', firstOrg, { root: true });
          localStorage.setItem('selectedOrganization', JSON.stringify(firstOrg));
        }
      } catch (error) {
        console.error('Error auto-selecting first organization:', error);
      }
    },
  },

  getters: {
    me: (state) => state.me,
    isMeSignedIn: (state) => state.isMeSignedIn,
    scopedCompany: (state) => state.scopedCompany,
    getToken: (state) => state.me?.token ?? null,
    getRefreshToken: (state) => state.me?.refreshToken ?? null,
    isAdmin: (state) => state.me?.usertype === 'ADMIN' || false,
    isOrgAdmin: (state) => state.me?.usertype === 'ORG' || false,
  },
};
